module.exports = __webpack_public_path__ + "dda0773dcd2adf7aaab9402d540009e8.png";